import React, {useEffect} from "react";
import useConstructionNewPageHook from "./hooks/useConstructionNewPageHook";
import IsaacLoading from "../../components/isaacLoading/IsaacLoading";
import styles from "./constructionNew.module.scss";
import ConstructionHeader from "./components/header/ConstructionHeader";
import ConstructionDetails from "./components/details/ConstructionDetails";
import ConstructionCommandBar from "./components/commandBar/ConstructionCommandBar";
import ConstructionBody from "./components/body/ConstructionBody";
import {useNavigate} from "react-router-dom";
import PathConstants from "../../routes/pathConstants";

const ConstructionNew: React.FunctionComponent = () => {
  const {construction, loading} = useConstructionNewPageHook();
  const navigate = useNavigate();

 useEffect(() => {
    if (loading) return;

    if(construction === undefined) {
      void navigate(PathConstants.Home);
    }
  }, [loading, construction, navigate]);

  if(construction === null || construction === undefined){
    return null;
  }

  return (
    <>
      <IsaacLoading loading={loading} message="Loading construction data..." />
      {!loading && (
        <div className={styles.constructionContainer}>
          <ConstructionHeader construction={construction} />
          <ConstructionDetails construction={construction} />
          <ConstructionCommandBar constructionStatus={construction.status} />
          <ConstructionBody construction={construction} />
        </div>
      )}
    </>
  );
};

export default ConstructionNew;
